module.exports = __webpack_public_path__ + "media/images/link-ombudsnotairebe-24e25cb2d2a989b128e82771801472a0.png";